<template>
  <div class="checkreportpage">
    <div class="resultlist">
      <span class="listline"></span>
      <p class="paylisttit">
        <span class="title">{{checkInfo.Name}}</span>
      </p>
      <div class="resultlistcon">
        <p>
          <span>申请单号：</span>
          <span>{{checkInfo.CheckNo}}</span>
        </p>
        <p>
          <span>申请科室：</span>
          <span>{{checkInfo.DptName}}</span>
        </p>
        <p>
          <span>开单医生：</span>
          <span>{{checkInfo.DctName}}</span>
        </p>
        <p>
          <span>执行科室：</span>
          <span>{{checkInfo.ExecDptName}}</span>
        </p>
        <p>
          <span>报告时间：</span>
          <span>{{checkInfo.Time}}</span>
        </p>
      </div>
    </div>
    <div class="resultlist">
      <span class="listline"></span>
      <p class="paylisttit">
        <span class="title">影像描述</span>
      </p>
      <div class="accountforbox">
        <p class="accountfor" v-for="item in checkInfo.Detail">{{item.Describes}}</p>
        <p class="accountfor">{{describes}}</p>
        <p/>
      </div>
    </div>
    <div class="resultlist">
      <span class="listline"></span>
      <p class="paylisttit">
        <span class="title">影像诊断</span>
      </p>
      <div class="accountforbox">
        <p class="accountfor" v-for="item in checkInfo.Detail">{{item.Diagnosis}}</p>
        <p class="accountfor">{{describes}}</p>
      </div>
    </div>
  </div>
</template>
<script>
import { GetCheckPresentation } from "@/services/getData.js";
import weui from "weui.js";
export default {
  name: "check-report",
  created: function() {
    this.getCheckPresentation();
  },
  data() {
    return {
      checkID: this.$route.query.checkID,
      checkInfo: [],
      describes: ""
    };
  },
  methods: {
    getCheckPresentation() {
      var loading = weui.loading("loading", {
        className: "custom-classname",
        content: "加载中"
      });
      GetCheckPresentation(this.checkID).then(response => {
        loading.hide();
        if (response.data.Result) {
          this.checkInfo = response.data.Extend;
          if (this.checkInfo.Detail.length > 0) {
            this.describes = "";
          } else {
            this.describes = "暂无数据";
          }
        } else {
        }
      });
    }
  }
};
</script>
<style>
.checkreportpage {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.checkreportpage .resultlist {
  box-sizing: border-box;
  width: 100%;
  height: auto;
  background-color: white;
  position: relative;
  padding-bottom: 0.2rem;
  margin-bottom: 0.2rem;
}

.checkreportpage .paylisttit {
  font-size: 0.26rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: #1592e4;
  border-bottom: 0.01rem solid rgba(61, 151, 209, 1);
  height: 0.79rem;
  line-height: 0.8rem;
  padding-left: 0.2rem;
  box-sizing: border-box;
  width: 100%;
}

.checkreportpage .resultlistcon {
  width: 100%;
  box-sizing: border-box;
  padding: 0 0.2rem;
}

.checkreportpage .resultlist > .resultlistcon > p {
  width: 100%;
  border-bottom: 0.01rem dotted #dddddd;
  height: 0.79rem;
  line-height: 0.8rem;
  font-size: 0.26rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
}

.checkreportpage .resultlist > .resultlistcon > p:last-child {
  border-bottom: none;
}

.checkreportpage .resultlist > .resultlistcon > p > span:first {
  color: #333333;
  text-align: left;
}

.checkreportpage .resultlist > .resultlistcon > p > span:last-child {
  color: #999999;
  text-align: right;
  float: right;
}

.checkreportpage .resultlist > .paylresultlistconiscon > p:last-child {
  border-bottom: none;
}

.checkreportpage .listline {
  display: block;
  position: absolute;
  width: 0.08rem;
  height: 0.8rem;
  background: rgba(21, 146, 228, 1);
  top: 0;
  left: 0;
}

.checkreportpage .accountforbox {
  width: 100%;
  box-sizing: border-box;
  padding: 0 0.2rem;
}

.checkreportpage .accountforbox .accountfor {
  width: 100%;
  font-size: 0.26rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  box-sizing: border-box;
  padding-top: 0.2rem;
}
</style>



// WEBPACK FOOTER //
// src/components/reportquery/check-report.vue